import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || '';
axios.defaults.baseURL = apiUrl && (apiUrl.startsWith('http://') || apiUrl.startsWith('https://'))
  ? apiUrl
  : '';

export const AuthContext = createContext();

const ADMIN_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || 'hoseaephraim50@gmail.com').toLowerCase();
const ADMIN_USERNAME = (process.env.REACT_APP_ADMIN_USERNAME || 'admin').toLowerCase();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then((response) => {
          if (response.data) {
            setUser(response.data);
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common.Authorization;
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post('/api/auth/login', { 
        email, 
        username: ADMIN_USERNAME,
        password 
      });
      const { token, user: userData } = response.data;
      localStorage.setItem('token', token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      setUser(userData);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Invalid credentials'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common.Authorization;
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, adminEmail: ADMIN_EMAIL }}>
      {children}
    </AuthContext.Provider>
  );
};

